import brand from 'brands/jcpenney'

export default brand
export const { clientInfo } = brand
export const { palette } = brand
export const brandImages = brand.images
